import React from 'react';
import {
  Button,
  Checkbox,
  Divider,
  ExpoImage,
  ScreenContainer,
  TextInput,
  Touchable,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const LoginScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [checkboxValue, setCheckboxValue] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const validateEmailAndPassword = (email, password) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setErrorMessage('');

    if (!email) {
      setErrorMessage('Email is required.');
      return false;
    }
    if (!emailRegex.test(email)) {
      setErrorMessage('Invalid email format.');
      return false;
    }

    if (!password) {
      setErrorMessage('Password is required.');
      return false;
    }
    if (password.length < 6) {
      setErrorMessage('Password must be at least 6 characters long.');
      return false;
    }

    return true;
  };
  const leadFunlDefaultAuthLoginPOST = LeadFunlDefaultApi.useAuthLoginPOST();
  const isFocused = useIsFocused();
  React.useEffect(() => {
    try {
      if (!isFocused) {
        return;
      }
      if (Constants['AUTH_TOKEN']?.length) {
        if (navigation.canGoBack()) {
          navigation.popToTop();
        }
        navigation.replace('DashboardScreen');
      } else {
      }
    } catch (err) {
      console.error(err);
    }
  }, [isFocused]);

  return (
    <ScreenContainer
      scrollable={false}
      hasSafeArea={true}
      hasTopSafeArea={false}
      style={StyleSheet.applyWidth(
        { justifyContent: 'space-between' },
        dimensions.width
      )}
    >
      {/* Contaner */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: 'stretch',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-between',
          },
          dimensions.width
        )}
      >
        {/* Details View */}
        <>
          {!(dimensions.width >= Breakpoints.Tablet) ? null : (
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
                  flex: 1,
                  justifyContent: {
                    minWidth: Breakpoints.Tablet,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              {/* Pantheonleads */}
              <ExpoImage
                allowDownscaling={true}
                cachePolicy={'disk'}
                contentPosition={'center'}
                transitionDuration={300}
                transitionEffect={'cross-dissolve'}
                transitionTiming={'ease-in-out'}
                {...GlobalStyles.ExpoImageStyles(theme)['Image 2'].props}
                resizeMode={'contain'}
                source={
                  imageSource(Images['officedotlogo']) ??
                  imageSource(
                    'https://xxax-vzp0-inbx.n7d.xano.io/vault/UQhMMSaq/5vlb7b8jgQYTHSxrZMJ1E4wm6LM/Kjie3A../Annuity+Logo+with+AFL.png'
                  )
                }
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ExpoImageStyles(theme)['Image 2'].style,
                    {
                      height: { minWidth: Breakpoints.Tablet, value: 300 },
                      width: { minWidth: Breakpoints.Tablet, value: '70%' },
                    }
                  ),
                  dimensions.width
                )}
              />
            </View>
          )}
        </>
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'stretch',
              flex: 1,
              justifyContent: [
                { minWidth: Breakpoints.Mobile, value: 'center' },
                { minWidth: Breakpoints.Tablet, value: 'center' },
              ],
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 20,
              width: [
                { minWidth: Breakpoints.Tablet, value: 400 },
                { minWidth: Breakpoints.Laptop, value: 500 },
                { minWidth: Breakpoints.Desktop, value: 600 },
                { minWidth: Breakpoints.BigScreen, value: 700 },
              ],
            },
            dimensions.width
          )}
        >
          {/* Heading */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: [
                  {
                    minWidth: Breakpoints.Mobile,
                    value: palettes.App['Custom Color_5'],
                  },
                  {
                    minWidth: Breakpoints.Tablet,
                    value: theme.colors.branding.primary,
                  },
                ],
                fontFamily: 'Poppins_700Bold',
                fontSize: 35,
                marginBottom: 10,
              },
              dimensions.width
            )}
          >
            {'Log into\nyour account'}
          </Text>
          {/* Email */}
          <TextInput
            autoCapitalize={'none'}
            autoCorrect={true}
            changeTextDelay={500}
            onChangeText={newEmailValue => {
              try {
                setEmail(newEmailValue);
              } catch (err) {
                console.error(err);
              }
            }}
            webShowOutline={true}
            editable={true}
            placeholder={'Email'}
            placeholderTextColor={theme.colors.text.light}
            style={StyleSheet.applyWidth(
              {
                backgroundColor: palettes.App['Custom Color_3'],
                borderBottomWidth: 1,
                borderColor: theme.colors.border.brand,
                borderLeftWidth: 1,
                borderRadius: 24,
                borderRightWidth: 1,
                borderTopWidth: 1,
                fontFamily: 'Poppins_400Regular',
                fontSize: 15,
                height: 48,
                marginTop: 10,
                paddingBottom: 8,
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 8,
              },
              dimensions.width
            )}
            value={email}
          />
          <View
            style={StyleSheet.applyWidth(
              { justifyContent: 'center' },
              dimensions.width
            )}
          >
            {/* Password */}
            <TextInput
              autoCapitalize={'none'}
              autoCorrect={true}
              changeTextDelay={500}
              onChangeText={newPasswordValue => {
                try {
                  setPassword(newPasswordValue);
                } catch (err) {
                  console.error(err);
                }
              }}
              webShowOutline={true}
              editable={true}
              placeholder={'Password'}
              placeholderTextColor={theme.colors.text.light}
              secureTextEntry={Boolean(!checkboxValue)}
              style={StyleSheet.applyWidth(
                {
                  backgroundColor: palettes.App['Custom Color_3'],
                  borderBottomWidth: 1,
                  borderColor: theme.colors.border.brand,
                  borderLeftWidth: 1,
                  borderRadius: 24,
                  borderRightWidth: 1,
                  borderTopWidth: 1,
                  fontFamily: 'Poppins_400Regular',
                  fontSize: 15,
                  height: 48,
                  marginBottom: 15,
                  marginTop: 15,
                  paddingBottom: 8,
                  paddingLeft: 20,
                  paddingRight: 20,
                  paddingTop: 8,
                },
                dimensions.width
              )}
              value={password}
            />
            <Checkbox
              onPress={newCheckboxValue => {
                const checkboxValue = newCheckboxValue;
                try {
                  setCheckboxValue(newCheckboxValue);
                } catch (err) {
                  console.error(err);
                }
              }}
              checkedIcon={'Ionicons/eye'}
              status={checkboxValue}
              style={StyleSheet.applyWidth(
                { position: 'absolute', right: 16, top: 28 },
                dimensions.width
              )}
              uncheckedIcon={'Ionicons/eye-off'}
            />
          </View>
          {/* View 2 */}
          <View
            style={StyleSheet.applyWidth(
              { alignItems: 'flex-end' },
              dimensions.width
            )}
          >
            {/* Forgot Password */}
            <Touchable
              onPress={() => {
                try {
                  navigation.navigate('ForgotPasswordScreen');
                } catch (err) {
                  console.error(err);
                }
              }}
            >
              {/* Forgot Password */}
              <Text
                accessible={true}
                selectable={false}
                style={StyleSheet.applyWidth(
                  {
                    color: palettes.App['Custom Color'],
                    fontFamily: 'Poppins_400Regular',
                    fontSize: 13,
                    textAlign: 'left',
                    textDecorationLine: 'underline',
                  },
                  dimensions.width
                )}
              >
                {'Forgot Password?'}
              </Text>
            </Touchable>
          </View>
          {/* error */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: palettes.App['Custom Color_5'],
                fontFamily: 'Poppins_400Regular',
                marginTop: 20,
                textAlign: 'center',
              },
              dimensions.width
            )}
          >
            {errorMessage}
          </Text>
          {/* Login */}
          <Button
            accessible={true}
            iconPosition={'left'}
            onPress={() => {
              const handler = async () => {
                try {
                  /* hidden 'Navigate' action */
                  const res = validateEmailAndPassword(email, password);
                  if (!res) {
                    return;
                  }
                  setIsLoading(true);
                  const loginResponse = (
                    await leadFunlDefaultAuthLoginPOST.mutateAsync({
                      email: email,
                      password: password,
                    })
                  )?.json;
                  setIsLoading(false);
                  if (loginResponse?.authToken) {
                    setGlobalVariableValue({
                      key: 'AUTH_TOKEN',
                      value: 'Bearer ' + loginResponse?.authToken,
                    });
                    if (navigation.canGoBack()) {
                      navigation.popToTop();
                    }
                    navigation.replace('DashboardScreen');
                  } else {
                    setErrorMessage(loginResponse?.message);
                  }
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            disabled={Boolean(isLoading)}
            loading={Boolean(isLoading)}
            style={StyleSheet.applyWidth(
              {
                backgroundColor: palettes.Brand.Primary,
                borderRadius: 24,
                color: palettes.App['Custom Color_4'],
                fontFamily: 'Poppins_500Medium',
                fontSize: 17,
                height: 46,
                marginTop: 15,
                textAlign: 'center',
              },
              dimensions.width
            )}
            title={'Login'}
          />
        </View>
      </View>
    </ScreenContainer>
  );
};

export default withTheme(LoginScreen);
